import Vue from 'vue';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { get } from 'lodash';

Vue.set(Vue.prototype, '_', { get });

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// Custom Validators
const REGEXP_VALIDATORS = {
  phoneNumber: /\+?(\d)?[ .-]?(\(?\d{3}\)?)[ .-]?(\d{3})[ .-]?(\d{4})/,
};

Object.entries(REGEXP_VALIDATORS).forEach(([validation_key, validation_exp]) => {
  extend(validation_key, {
    validate: (value) => validation_exp.test(value),
    message: (field) => `The ${field} is not valid`,
  });
});

extend('petNameExists', {
  params: ['existingPetNames'],
  validate: (value, { existingPetNames }) => !existingPetNames.map((name) => name.toLowerCase()).includes(value.toLowerCase()),

  message: 'You can only have one pet with the same name! Please enter a unique pet name.',
});

extend('noEmojis', {
  validate: (value) =>
    !value.match(
      /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g
    ),

  message: 'Sorry, but this field does not accept emojis.',
});

extend('before', {
  params: ['valid'],
  validate: (value, { valid }) => valid,
  message: 'Select a tag style and size before entering text',
});

const minMaxNumericHandler = (value, { min, max, minMessage, maxMessage, invalidMessage }) => {
  if (value == null || value === '') {
    return { valid: true };
  }

  const numericValue = Number(value);

  if (Number.isNaN(numericValue)) {
    return {
      valid: false,
      data: { message: invalidMessage },
    };
  }

  const minBoundary = min == null ? null : Number(min);
  if (minBoundary !== null && numericValue < minBoundary) {
    return {
      valid: false,
      data: { message: minMessage },
    };
  }

  const maxBoundary = max == null ? null : Number(max);
  if (maxBoundary !== null && numericValue > maxBoundary) {
    return {
      valid: false,
      data: { message: maxMessage },
    };
  }

  return { valid: true };
};

extend('minMaxNumeric', {
  params: ['min', 'max', 'minMessage', 'maxMessage', 'invalidMessage'],
  validate: minMaxNumericHandler,
  message: (_, { _value_, ...params }) => minMaxNumericHandler(_value_, params)?.data?.message,
});